import axios from 'axios'

const instance = axios.create({
  // baseURL: 'https://dev.bibomart.net/customer-tracking'
   baseURL: 'https://prod.bibomart.net/customer-tracking'
});

instance.interceptors.request.use(function (config) {
    return config;
});

instance.interceptors.response.use((response) => {
    return response.data
}, error => {
  return Promise.resolve({ error });
})

export default instance;